import { Button } from "@/components/ui/button"
import {
    Popover,
    PopoverContent, PopoverContnetWithoutPortal,
    PopoverTrigger,
} from "@/components/ui/popover"
import { useEffect, useState } from 'react'
import { Input } from '@/components/ui/input.jsx'
import { Icon } from '@iconify/react'
import { handleError } from '@/services/errorHandler.js'
import { CircleLoader } from '@/components/loader/CircleLoader.jsx'

// options - needs to be an array of objects with 'value' and 'label' properties
export function Combobox({ className = '', placeholder, options = [], onSearch, value, setValue, isOpeningInsideModal = false, disableActiveColor = false, optionClassName, searchPlaceholder = 'Search...', onConfigureAdAccounts, disablePortal }) {

    const [open, setOpen] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [filterValue, setFilterValue] = useState("")

    const chosenOption = value ? options.find((option) => option.value === value) : null


    const applySearch = async () => {
        try {
            setIsLoading(true)
            if (!filterValue) {
                return
            }
            if (onSearch) {
                await onSearch(filterValue)
            }
        } catch (e) {
            console.log(e)
            handleError(e)
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if (filterValue) {
            const delayDebounceFn = setTimeout(applySearch, 300)
            return () => clearTimeout(delayDebounceFn)
        }
    }, [filterValue])

    const filteredOptions = options.filter((option) => option.label.toLowerCase().includes(filterValue.toLowerCase()))

    let content = filteredOptions
        .map((option) => (
            <div
                key={option.value}
                className={`flex items-center gap-2 cursor-pointer transition hover:text-primary ${chosenOption?.value === option.value ? "text-primary" : "text-muted-foreground"} ${optionClassName}`}
                onClick={() => {
                    setValue(option)
                    setOpen(false)
                }}
            >

                {chosenOption?.value === option.value ? <Icon icon="mingcute:check-line" className="h-3 w-3" /> : null}
                {option.imgUrl ? <img src={option.imgUrl} alt={option.value} className="w-5 h-5 rounded-full" /> : null}
                {option.icon ? <Icon className="flex-shrink-0" icon={option.icon} /> : null}
                <div className="truncate">{option.label}</div>

            </div>
        ))

    if (filteredOptions.length === 0) {
        content = <div className="text-gray-500 text-center">- No results found -</div>
    }

    if (isLoading) {
        content = <CircleLoader className="m-auto p-1" />
    }

    return (
        <Popover
            modal={isOpeningInsideModal}
            open={open}
            onOpenChange={setOpen}
        >
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    role="combobox"
                    aria-expanded={open}
                    className={`w-[200px] justify-between font-normal ${className}`}
                >
                    <div className={`flex gap-2 items-center truncate ${(chosenOption && !disableActiveColor) ? 'text-primary' : null}`}>
                        {chosenOption?.imgUrl ? <img src={chosenOption.imgUrl} alt={chosenOption.value} className="w-5 h-5 rounded-full" /> : null}
                        {chosenOption?.icon ? <Icon icon={chosenOption.icon} /> : null}
                        {chosenOption ? chosenOption.label : placeholder}
                    </div>
                    <Icon icon="bx:chevron-down" className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                </Button>
            </PopoverTrigger>
            {
                disablePortal ? (
                    <PopoverContnetWithoutPortal className="p-0 w-[210px]">
                        <div className="">
                            <Input
                                value={filterValue}
                                placeholder={searchPlaceholder}
                                onChange={(e) => setFilterValue(e.target.value)}
                            />
                            <div className="flex flex-col gap-3 p-2 font-light text-sm overflow-y-scroll max-h-[215px]">
                                {content}
                            </div>
                        </div>
                        {
                            onConfigureAdAccounts && (
                                <Button
                                    onClick={onConfigureAdAccounts}
                                    className="w-full border-t text-xsm"
                                    variant="primary-ghost"
                                    size="mini"
                                >
                                    Configure Ad Accounts
                                </Button>
                            )
                        }
                    </PopoverContnetWithoutPortal>
                ) : (
                    <PopoverContent className="p-0 w-[210px]">
                        <div className="">
                            <Input
                                value={filterValue}
                                placeholder={searchPlaceholder}
                                onChange={(e) => setFilterValue(e.target.value)}
                            />
                            <div className="flex flex-col gap-3 p-2 font-light text-sm overflow-y-scroll max-h-[215px]">
                                {content}
                            </div>
                        </div>
                        {
                            onConfigureAdAccounts && (
                                <Button
                                    onClick={onConfigureAdAccounts}
                                    className="w-full border-t text-xsm"
                                    variant="primary-ghost"
                                    size="mini"
                                >
                                    Configure Ad Accounts
                                </Button>
                            )
                        }
                    </PopoverContent>
                )
            }


        </Popover>
    )
}
